import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FormsModule } from '@angular/forms';

// Enabling the animations module
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// wow animation module  
import { NgwWowModule } from 'ngx-wow';
// shared module
import { SharedModule } from './shared/shared.module';
// core module
import { CoreModule } from './core/core.module';
// Apollo Modules
import { ApolloModule } from 'apollo-angular';
import { HttpLinkModule } from 'apollo-angular-link-http';
// Angular Fire Module
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { GraphQLModule } from './graphql.module';
// ngx-translate
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { RefreshTokenInterceptor } from './core/interceptors/refresh-token.interceptor';


// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



@NgModule({

  declarations: [
    AppComponent,
  ],

  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgwWowModule,
    SharedModule,
    CoreModule,
    ApolloModule,
    HttpLinkModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    GraphQLModule,
    AngularFireStorageModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
          provide: [TranslateLoader, TranslateModule],
          useFactory: createTranslateLoader,
          deps: [HttpClient]
      }
  })
  ],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
  ],

  bootstrap: [AppComponent]


})
export class AppModule {
  constructor() { }
}